module.exports = __webpack_public_path__ + "img/commander.5c046dc5.jpg";